import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import i18n from 'src/lib/i18n/i18n';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

export class BuddiesNoFriends extends View {
  constructor(opts?: ViewOpts) {
    super({
      ...opts,
      width: 550,
      height: 574,
    });

    // Background
    new ImageScaleView({
      superview: this,
      image: 'assets/ui/shared/frames/rounded_rect_white.png',
      width: 550,
      height: 574,
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 20, right: 20 },
        vertical: { top: 20, bottom: 25 },
      },
    });

    // Title
    new LangBitmapFontTextView({
      superview: this,
      x: 40,
      y: 70,
      align: 'center',
      verticalAlign: 'center',
      size: 30,
      font: 'Body',
      color: '#9C693A',
      width: this.style.width - 80,
      height: 40,
      localeText: () => i18n('match2.buddies.invitePopup.playWithFriends'),
    });

    // Image
    new ImageScaleView({
      superview: this,
      image: 'assets/ui/buddies/popupInvite/full_party.png',
      width: 313,
      height: 218,
      centerOnOrigin: true,
      x: this.style.width / 2,
      y: this.style.height / 2 - 20,
      scaleMethod: 'contain',
    });

    // Message
    new LangBitmapFontTextView({
      superview: this,
      align: 'center',
      size: 28,
      font: 'Body',
      color: '#9C693A',
      width: this.style.width - 80,
      height: 150,
      wordWrap: true,
      x: 40,
      y: 450,
      localeText: () => i18n('match2.buddies.invitePopup.noFriends'),
    });
  }
}
